export const blockIconsActivitiesConstructionNew = (
	<span className='material-symbols-outlined'>construction</span>
);
